import ViewSponsorshipTier from "./ViewSponsorshipTier";

export default ViewSponsorshipTier